import React from 'react';
import { Select } from 'antd';

const CURRENCIES = [
  { code: 'USD', label: 'USD ($)' },
  { code: 'CLP', label: 'CLP (CLP$)' },
  { code: 'BRL', label: 'BRL (R$)' },
];

interface CurrencySelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ value, onChange, disabled }) => (
  <Select
    value={value}
    onChange={onChange}
    disabled={disabled}
    placeholder="Select currency"
    style={{ width: '100%' }}
    options={CURRENCIES.map(cur => ({
      value: cur.code,
      label: cur.label,
    }))}
  />
);

export default CurrencySelector; 